<template>
    <OverlayLoader :isLoading="!isLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="`${this.$translate.text('clients.connections.pricing')} ( ${connectionName} )`"
                />

                <ConnectionMenu></ConnectionMenu>

                <div v-if="disablePricing">
                    <Alert>{{ t('alert.pricing.not.needed') }}</Alert>
                </div>
                <div v-else>
                    <WhiteTable :labels="[$translate.text('clients.connections.pricing.brand'), $translate.text('general.categories'), $translate.text('clients.connections.pricing.marge')]">
                        <template slot="table-data">
                            <tr v-for="price in pricing" :key="price.id">
                                <td v-if="price.brand" style="width: 30%;">{{ price.brand }}</td>
                                <td v-else style="width: 30%;">*</td>
                                <td style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 1px; width: 30%;">{{ flattenCategories(price.categories) }}</td>
                                <td style="width: 30%;">{{ price.marge }}</td>
                                <td class="align-right" style="width: 10%;">
                                    <i class="fal fa-edit" @click="$router.push({ name: 'Clients Connections Pricing Edit', params: { id: $route.params.id, pricing_id: price.id } })" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                                    <i class="fal fa-trash-alt" @click="deletePricing(price.id)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                                </td>
                            </tr>
                            <tr v-if="!pricing.length">
                                <td colspan="6">{{ t('general.no_results_found') }}</td>
                            </tr>
                        </template>
                    </WhiteTable>
                </div>
            </div>

            <FloatingButton
                @clicked="$router.push({ name: 'Clients Connections Pricing Add' })"
                :show="!disablePricing"
            />
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';
import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import FloatingButton from '@/components/FloatingButton/FloatingButton';
import ConnectionMenu from '@/components/ConnectionMenu/ConnectionMenu';

import Alert from '@/components/Alert/Alert';

export default {
    name: 'Pricing',

    components: {
        ConnectionMenu,
        PageHeader,
        OverlayLoader,
        WhiteTable,
        FloatingButton,
        Alert,
    },

    data() {
        return {
            pricing: [],
            disablePricing: false,
            connectionName: '',
            loaded: {
                items: {
                    pricing: false,
                    connection: false,
                },
            },

            // connection: [],
            // connectionLoaded: false,
        };
    },

    created() {
        this.getPricing();
        this.getConnection();
        this.getCombined();
    },

    methods: {
        getPricing() {
            this.API.clients.connections.pricing.index(this.$route.params.id)
                .then((response) => {
                    this.pricing = response.data.data;
                    this.loaded.items.pricing = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    const connection = response.data.data;
                    this.connectionName = response.data.data.name;
                    this.loaded.items.connection = true;
                    this.getCombined(connection.feed_id);
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombined(feedId) {
            this.API.clients.feeds.combine.combined(feedId)
                .then(response => {
                    if (response.data.data) {
                        const data = response.data.data;
                        if (data.purchase_price[0] === null) {
                            this.disablePricing = true;
                        }
                    }
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        deletePricing(id) {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    this.API.clients.connections.pricing.destroy(this.$route.params.id, id)
                        .then(() => {
                            this.getPricing();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        flattenCategories(categories) {
            if (categories === null) {
                return '*';
            }

            const joins = [];

            categories.forEach(category => {
                joins.push(category.label);
            });

            return joins.join(', ');
        },
    },

    computed: {
        isLoaded() {
            return this.loaded.items.connection && this.loaded.items.pricing;
        },
    },
};
</script>

<style scoped>
    .white-table {
        padding-top: 20px;
    }
</style>
